import React, {useState,useContext} from 'react'
import { DataContext } from './ContextProvider'


const PropertyFilter = () => {
  const [selectedBedrooms, setSelectedBedrooms] = useState('');
  const [selectedBathrooms, setSelectedBathrooms] = useState('');

    const {
        properties,
        selectedProperty,
        setSelectedProperty,
        setPropertiesDetails,
        propertiesDeatils,
        getData
    } = useContext(DataContext)

    const filterProperty = (category) => {
        if (!category) {
          return propertiesDeatils;
        }

        return properties.filter((data) => {
          switch (category) {
            case data.bedrooms:
              return data.bedrooms;
            case data.bathrooms:
              return data.bathrooms;
            case data.location.city:
              return data.location.city;
            case '':
              return;
            case '100':
              return data.price < 100 && data.price;
            case '300':
              return data.price >= 100 && data.price <= 300 && data.price;
            case '500':
              return data.price > 300 && data.price <= 500 && data.price;
            case '501':
              return data.price > 500 && data.price;
            default:
              return;
          }
        });
    };

    const handlePropertyChange = (e, propertyName) => {
      const selectedValue = e.target.value;
  
      if (propertyName === 'bedrooms') {
        setSelectedBedrooms(selectedValue);
      } else if (propertyName === 'bathrooms') {
        setSelectedBathrooms(selectedValue);
      }
  
      setSelectedProperty(selectedValue);
      setPropertiesDetails(filterProperty(selectedValue));
    };

  return (
    <div>
        <ul className="property-filter">
          <li onClick={() => getData()}>
          <label htmlFor="listing">All listing</label>
            <select name="" id="listing">
            <option value="">See all listing</option>
            <option value="" onClick={() => getData()} >All listing</option>
            </select>
          </li>
          <li>
            <label htmlFor="price">Price:</label>
            <select name="price" id="price" onChange={handlePropertyChange}  value={selectedProperty}>
              <option value="">Price</option>
              <option value="100">Less than 100m </option>
              <option value="300">100m - 300m </option>
              <option value="500">300m - 500m </option>
              <option value="501">500m and above</option>
            </select>
          </li>
          <li>
            <label htmlFor="bathroom">Bathroom:</label>
            <select 
             name="bathroom"
             id="bathroom" 
             onChange={(e) => handlePropertyChange(e, 'bathrooms')}
             value={selectedBathrooms}
            >
              <option value="">Bathrooms</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5">5</option>
              <option value="6">6</option>
              <option value="7">7</option>
            </select>
          </li>
          <li>
            <label htmlFor="bedrooms">Bedrooms:</label>
            <select 
              name="bedrooms" 
              id="bedrooms" 
              onChange={(e) => handlePropertyChange(e, 'bedrooms')}
              value={selectedBedrooms}
            >
              <option value="">Bedrooms</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5">5</option>
              <option value="6">6</option>
              <option value="7">7</option>
            </select>
          </li>
          <li>
            <label htmlFor="location">Location:</label>
            <select name="location" id="location" onChange={handlePropertyChange}  value={selectedProperty}>
              <option value="">Location</option>
              <option value="Lekki Phase 1">Lekki</option>
              <option value="Oniru, Victoria Island">Oniru</option>
            </select>
          </li>
      </ul>
    </div>
  )
}

export default PropertyFilter
